import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { Separator } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { SOURCES } from '@mc/share'
import { useStaticData } from '@mc/static-data-react'
import TableOfContents from 'components/TableOfContents'
import {
  useCourseBySlug,
  useTopArticles,
  useInstructorsByCategory,
} from 'libs/client/api'
import {
  mapInstructorToAsideItem,
  mapArticleToAsideItem,
  mapArticleSubsectionsToNavItems,
  getSocialLinks,
  getUrlWithoutQueryParams,
} from 'libs/utils'
import AsideList from '../../../components/AsideList'
import Aside from '../Aside'
import { Recipe, Subsections } from '../Subsection'

const Details = () => {
  const { article } = useStaticData()
  const { t } = useTranslation('@mc/next')
  const { asPath } = useRouter()
  const { courseBySlug } = useCourseBySlug(article.featuredCourseSlug)
  const { instructorsByCategory, error: instructorsError } =
    useInstructorsByCategory(4, article.mcCategorySlug)
  const { topArticles, error: topArticlesError } = useTopArticles(
    article.category.id,
  )
  const urlToShare = getUrlWithoutQueryParams(asPath)
  const socialLinks = getSocialLinks(
    article.heroImage?.url,
    article.title,
    urlToShare,
  )
  const modalShareData = useMemo(
    () => ({
      article,
      title: article.title,
      source: SOURCES.ARTICLES,
    }),
    [article],
  )

  return (
    <section className='container' data-testid='details'>
      <div className='row'>
        <Aside
          socialLinks={socialLinks}
          modalShareData={modalShareData}
          useDeprecated={false}
          modalTitle={t('article.details.modal.share.title')}
        />
        <div className='col-lg-8 col-sm-12'>
          <TableOfContents
            navItems={mapArticleSubsectionsToNavItems(article, courseBySlug)}
            title={t('article.details.tableOfContents.title')}
          />
          <Separator className='mc-my-10' />
          <Subsections subsections={article.articleSubsections} />
          <Recipe />
        </div>
        <div className='col-3 d-none d-lg-flex flex-column justify-content-evenly'>
          {instructorsByCategory && !instructorsError && (
            <AsideList
              title={`our ${article.category.name} courses`}
              items={instructorsByCategory.map(mapInstructorToAsideItem)}
            />
          )}
          {topArticles && !topArticlesError && (
            <AsideList
              title={t('article.topArticle.title')}
              items={topArticles.map(mapArticleToAsideItem)}
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default Details
